module.exports = __webpack_public_path__ + "img/threads.bf529248.svg";